import type { StackProps } from "@mui/material";
import { Stack } from "@mui/material";
import { Link } from "react-router";
import useMergedSx from "@entrilia/shared/hooks/useMergedSx";

interface Props extends StackProps {
  to: string;
}

const NewsItemLinkWrapper = ({ to, sx, children, ...stackProps }: Props) => {
  const mergedSx = useMergedSx(
    { color: "inherit", textDecoration: "none", "&:hover .news-item-title": { color: "primary.main" } },
    sx
  );

  return (
    <Stack component={Link} to={to} {...stackProps} sx={mergedSx}>
      {children}
    </Stack>
  );
};

export default NewsItemLinkWrapper;
